import React from 'react';
// @ts-ignore
import styles from "./WizardCarouselSlideIndicator.module.scss";

interface Props {
	activeIndex: number;
	indexes: number[];
	setActiveSlide: (index: number) => void;
}

const WizardCarouselSlideIndicator: React.FC<Props> = ({indexes, activeIndex, setActiveSlide}) => {

	return (
		<div className={styles.wrapper}>
			{indexes.map((index) => <div className={index === activeIndex ? styles.activeDot : styles.dot} onClick={() => setActiveSlide(index)} key={index}/>)}
		</div>
	)
}

export default WizardCarouselSlideIndicator;